import Modal from "react-bootstrap/Modal";

const CustModal = ({ show }) => {
  return (
    <Modal show={show} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title >Fetching Data</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pulse">Please wait...</Modal.Body>
    </Modal>
  );
};

export default CustModal;
